import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import SettingsAlerts from "./settings_alerts";
import { updateProfile } from "../../../actions/settings_actions";
import { showToast } from "../../../actions/toast_actions";

const msp = (state) => ({
  currentUser: state.entities.users[state.session.currentUser.id]
});

const mdp = (dispatch) => ({
  updateProfile: (user, user_id) => dispatch(updateProfile(user, user_id)),
  showToast: (message) => dispatch(showToast(message))
});

export default withRouter(connect(msp, mdp)(SettingsAlerts));
